// extracted by mini-css-extract-plugin
export default {"br":"Bk","w80":"Ck","card":"Ek","wrapper":"Fk","fullView":"Gk","profilePic":"Hk","comment":"Ik","animate":"Jk","shimmer":"Kk","square":"Lk"};
    if(module.hot) {
      // 1711394575476
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  